import React, { Component } from 'react';
import './Video.css';

class Video extends Component {
  render() {
    const {
      videoUrl,
      autoplay,
      fullscreen,
      title,
      titleFontSize,
      description
    } = this.props.contentBlock;

    return (
      <div className={`video`}>
        {title && (
          <div className={`text-title ${titleFontSize ? titleFontSize : ''}`}>
            {title}
          </div>
        )}
        {description && <p>{description}</p>}
        {videoUrl && (
          <div className="player">
            <iframe
              type="text/html"
              src={`${videoUrl}${autoplay ? '?autoplay=1' : ''}`}
              allowFullScreen={fullscreen ? true : false}
              frameBorder="0"
              title={title || 'Video'}
            />
          </div>
        )}
      </div>
    );
  }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/content-blocks/Video/Video.js